import { Injectable } from "@angular/core"
import { parse, ParseError as PapaParseError } from 'papaparse'
import dropRightWhile from 'lodash-es/dropRightWhile'
import isEmpty from 'lodash-es/isEmpty'

export type CsvCell = string // TODO make more diverse
export type CsvRow = CsvCell[]
export type ParseError = PapaParseError

interface ReaderOptions {
  header: boolean // Each row will be organized by field name instead of index if there is a header row
}

// NOTE: 'application/vnd.ms-excel' If you have excel installed on windows,
// any csv gets this mime-type, same as excel
// We'll want to validate it in the future to make sure it's actually text
// https://github.com/mholt/PapaParse/issues/18
// NOTE2: CHROMEBOOKs seems to not give CSV files a mime-type so we whitlisted ''
const WHITE_LIST = [
  'text/csv',
  'application/vnd.ms-excel',
  ''
]

@Injectable({
  providedIn: 'root'
})
export class CsvReader {
  readRows = (file: File, options?: ReaderOptions): Promise<CsvRow[]> => {
    return new Promise((resolve, reject) => {
      if (file) {
        if (WHITE_LIST.includes(file.type))
          parse(file as any, {
            ...options,
            skipEmptyLines: 'greedy',
            dynamicTyping: true,
            complete: ({ data, errors }: { data: CsvRow[], errors: ParseError[] }, file) => {
              if (errors.length > 0) {
                const err = errors.map(e => e.message).join(', ')
                reject(err)
              }
              else if (data) {
                data[0] = dropRightWhile((data[0] || []), isEmpty)
                const headerRowLength = (data[0] || []).length
                // Remove data from rows if there is no corresponding header
                data = data.map(row => dropRightWhile(row, (data, index) => index + 1 > headerRowLength))
                resolve(data)
              }
            }
          })
        else {
          reject(`File must be a csv, you uploaded a ${file.type}`)
        }
      }
      else {
        reject('File not found')
      }
    })
  }
}
export default CsvReader
